/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class ActionRequest {
    constructor(data) {
        if (data) {
            Object.assign(this, data);
            this.emissionDate = this.getDateWithoutSecond(this.emissionDate);
            if (this.arrivalDate) {
                this.arrivalDate = this.getDateWithoutSecond(this.arrivalDate);
            } else {
                this.arrivalDate = this.getDateWithoutSecond(this.emissionDate);
            }

            if (this.resolutionDate) {
                this.resolutionDate = this.getDateWithoutSecond(this.resolutionDate);
            } else {
                this.resolutionDate = this.getDateWithoutSecond(this.emissionDate);
            }
        } else {
            this.alarms = [];
            this.actions = [];
            let date = new Date(Date.now());
            this.arrivalDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
            this.emissionDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
        }
    }

    /**
     * Sets the alarm of this action request.
     *
     * @param {Array} alarmIds Array of alarm IDs.
     */
    setAlarms(alarmIds) {
        this.alarms.splice(0);
        alarmIds.forEach(alarmId => this.alarms.push({id: alarmId}));
    }

    /**
     * Tells whether an alarm is already selected in this action request.
     *
     * @param {Number} alarmId Alarm ID.
     * @return {Boolean} True if the alarm is already selected.
     */
    containsAlarm(alarmId) {
        return this.alarms.findIndex(existingAlarm => (existingAlarm.id === alarmId)) !== -1;
    }

    /**
     * Removes an alarm from this action request.
     *
     * @param {Number} alarmId Alarm ID.
     */
    removeAlarm(alarmId) {
        const index = this.alarms.findIndex(existingAlarm => (existingAlarm.id === alarmId));
        if (index !== -1) {
            this.alarms.splice(index, 1);
        }
    }

    /**
     * Convert a string date to a Date format YYYY-mm-dd hh:mm
     *
     * @param {String} the string date
     */
    getDateWithoutSecond(stringDate) {
        let date = new Date(stringDate);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes());
    }
}

export { ActionRequest };



// WEBPACK FOOTER //
// ./src/main/front/scripts/model/ActionRequest.js